import { App } from "../../ts/app";
import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class CommentListController extends Controller {
    tabId: number | null = null;

    expanded: Record<string, boolean> = {};

    constructor() {
        super({
            logLabel: "CommentListController",
        });
    }

    public initialize({
        tabId,
    }: {
        tabId: number,
    }): void {
        this.tabId = tabId;
        this.expanded = {};
        if (!App.loggedIn) {
            this.bindClick({
                elementId: 'comment-list-log-in-to-leave-comment-button',
                handler: () => {
                    window.loginDialogController.open(null);
                },
            })
        }
        this._bindToShowRepliesToggleButtons();
        this._setState();
        Logger.info(this.logLabel, "Initialized");
    }

    private _setState(): void {
        const childCommentSections = document.querySelectorAll<HTMLElement>(".child-comments");
        for (const section of childCommentSections) {
            const rootCommentId = section.dataset.rootCommentId!;
            const isExpanded = this.expanded[rootCommentId] || false;
            section.classList.toggle("collapsed", !isExpanded);
        }

        const buttons = document.querySelectorAll<HTMLButtonElement>(".show-replies-button");
        for (const button of buttons) {
            const rootCommentId = button.dataset.rootCommentId!;
            const isExpanded = this.expanded[rootCommentId] || false;
            button.textContent = isExpanded ? "Hide Replies" : "Show Replies";
        }
    }

    private _bindToShowRepliesToggleButtons(): void {
        const buttons = document.querySelectorAll<HTMLButtonElement>(".show-replies-button");
        for (const button of buttons) {
            const rootCommentId = button.dataset.rootCommentId!;
            this.expanded[rootCommentId] = false;
            button.addEventListener("click", () => {
                this.expanded[rootCommentId] = !this.expanded[rootCommentId];
                this._setState();
            });
        }
    }
}
